import React, { useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Img, Input, Text } from "components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEyeSlash } from "react-icons/fa6";
import { IoEye } from "react-icons/io5";
import ReCAPTCHA from "react-google-recaptcha";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const LogInEmptyPage = () => {
  const [captchaToken, setCaptchaToken] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");

  let navigate = useNavigate();
  const [showpass, setShowpass] = useState(false);
  const [user, setuser] = useState({
    company_id: "",
    company_designation_id: "",
    name: "",
    captchaToken: captchaToken,
    mobilenumber: "",
    email: "",
    login_username: "",
    login_password: "",
    createdby: "",
  });
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const Base_url = process.env.REACT_APP_URL;

  const handleInputChange = (name, value) => {
    setuser(() => ({
      ...user,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   const token = sessionStorage.getItem("token");
  //   if (token) {
  //     navigate("/dashboardtestall");
  //   } else {
  //     navigate("/");
  //   }
  // }, []);

  useEffect(() => {
    if (email.trim() === "") {
    setCompany([]);
    setSelectedCompany(""); // ← correct place
    return;
  }
    if (email.length > 2) {
      axios.post("/api/authentication/purple-fusion-api/user_by_email", {
        email: email
      })
        .then(res => {
          setCompany(res.data);
          console.log(res.data);
          
        })
        .catch(err => console.log(err));
    }
  }, [email]);


  const otpSubmit = (e) => {
    navigate("/otpform");
  };

  const onCaptchaChange = (value) => {
    setCaptchaToken(value); // Save the token returned from Google
    setuser((prevUser) => ({
      ...prevUser,
      captchaToken: value,
    }));
  };

  // const onHandleSubmit = (e) => {
  //   e.preventDefault();

  //   // if (!captchaToken) {
  //   //   toast.error("Please verify you are not a robot.");
  //   //   return;
  //   // }
  //   if (!executeRecaptcha) {
  //     toast.error("reCAPTCHA not ready yet");
  //     return;
  //   }

  //   axios
  //     .post("/api/authentication/purple-fusion-api/authenticate", user)
  //     .then((response) => {
  //       console.log(response.data);
  //       sessionStorage.setItem("token", response.data.token);
  //       sessionStorage.setItem("status", response.data.status);
  //       sessionStorage.setItem("userId", response.data.userId);

  //       sessionStorage.setItem("companyId", response.data.companyId);
  //       const erplistArray = response.data.erplist;
  //       sessionStorage.setItem("erplist", JSON.stringify(erplistArray));

  //       if (response.data.message === "Login Successfully!") {
  //         // sessionStorage.setItem("tab", "SalesOrder");
  //         // navigate("/salesorderreport/all");

  //         sessionStorage.setItem("tab", "revenuereport");
  //         navigate("/dashboardtestall");
  //       } else {
  //         toast.error(response.data.message, {
  //           autoClose: 2000,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       navigate("*");
  //     });
  // };

  const onHandleSubmit = async (e) => {
    e.preventDefault();

    // if (!executeRecaptcha) {
    //   toast.error("reCAPTCHA not ready yet");
    //   return;
    // }
    if (!selectedCompany) {
    toast.error("Please select a company", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    return; // Exit the function early
  }

    try {
      // const tokenCaptcha = await executeRecaptcha("login"); // 'login' is your action
      // console.log("reCAPTCHA Token", token);

      const updatedUser = {
        ...user,
        company_id: selectedCompany
        // captchaToken: tokenCaptcha,
      };

      axios
        .post("/api/authentication/purple-fusion-api/authenticate", updatedUser)
        .then((response) => {
          const data = response.data;
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("status", data.status);
          sessionStorage.setItem("userId", data.userId);
          sessionStorage.setItem("companyId", data.companyId);
          sessionStorage.setItem("erplist", JSON.stringify(data.erplist));

          if (data.message === "Login Successfully!") {
            sessionStorage.setItem("tab", "revenuereport");
            navigate("/dashboardtestall");
          } else {
            toast.error(data.message, { autoClose: 2000 });
          }
        })
        .catch((error) => {
          console.log(error);
          // navigate("*");
        });
    } catch (err) {
      console.error("Error executing reCAPTCHA", err);
      toast.error("reCAPTCHA verification failed");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="bg-white-A700 flex flex-col font-inter items-start justify-start mx-auto w-full">
        <div className="flex md:flex-col flex-row md:gap-10 gap-[86px] items-start justify-start md:px-5 w-[94%] md:w-full">
          <div className="bg-gray-100 flex flex-col gap-[21px] items-center justify-end p-[75px] md:px-10 sm:px-5 w-[56%] md:w-full">
            <div className="flex flex-col items-start justify-start mt-1.5 sm:px-5 px-[22px] py-3 w-auto sm:w-full">
              <div className="md:h-[347px] h-[500px] p-0.5 relative w-[500px] sm:w-full">
                <div className="absolute bottom-[2%] md:h-[347px] h-[454px] inset-x-[0] mx-auto w-[99%] sm:w-full">
                  <div className="md:h-[347px] h-[454px] m-auto w-full">
                    <div className="md:h-[347px] h-[454px] m-auto w-full">
                      <div className="absolute bottom-[0] md:h-[299px] h-[349px] inset-x-[0] mx-auto w-full">
                        <div className="absolute bottom-[0] md:h-[299px] h-[328px] inset-x-[0] mx-auto w-full">
                          <Img
                            className="absolute bottom-[0] h-[285px] inset-x-[0] mx-auto"
                            src="images/img_floor.svg"
                            alt="floor"
                          />
                          <Img
                            className="absolute h-[299px] inset-x-[0] mx-auto top-[0]"
                            src="images/img_shadow.svg"
                            alt="shadow"
                          />
                        </div>
                        <Img
                          className="absolute h-[103px] right-[16%] top-[0]"
                          src="images/img_calcuator.svg"
                          alt="calcuator"
                        />
                      </div>
                      <div
                        className="absolute bg-cover bg-no-repeat flex flex-col h-[348px] items-end justify-start left-[5%] p-[23px] sm:px-5 top-[0] w-[65%]"
                        style={{
                          backgroundImage: "url('images/img_group36.svg')",
                        }}
                      >
                        <div
                          className="bg-cover bg-no-repeat flex flex-col h-[270px] items-end justify-start my-4 p-4 w-3/4 md:w-full"
                          style={{
                            backgroundImage: "url('images/img_group37.svg')",
                          }}
                        >
                          <Img
                            className="h-[227px] mb-2.5"
                            src="images/img_document.svg"
                            alt="document"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="absolute bottom-[7%] flex flex-row gap-[13px] items-start justify-between left-[2%] w-[73%]">
                      <Img
                        className="h-[82px] mt-2.5"
                        src="images/img_coins.svg"
                        alt="coins"
                      />
                      <Img
                        className="h-[142px]"
                        src="images/img_ticket1.svg"
                        alt="ticketOne"
                      />
                    </div>
                  </div>
                  <div className="absolute flex flex-col h-max inset-y-[0] items-center justify-start my-auto right-[4%] w-[32%]">
                    <div className="md:h-[263px] h-[314px] relative w-full">
                      <Img
                        className="absolute bottom-[0] h-[185px] inset-x-[0] mx-auto"
                        src="images/img_xmlid5936.svg"
                        alt="xmlid5936"
                      />
                      <div className="absolute h-[263px] inset-x-[0] mx-auto top-[0] w-full">
                        <div className="h-[263px] m-auto w-full">
                          <div className="absolute h-[263px] inset-y-[0] my-auto right-[0] w-[62%]">
                            <Img
                              className="absolute h-[263px] inset-y-[0] my-auto right-[0]"
                              src="images/img_group_black_900.svg"
                              alt="group"
                            />
                            <Img
                              className="absolute h-[139px] left-[0] top-[6%]"
                              src="images/img_xmlid5926.svg"
                              alt="xmlid5926"
                            />
                          </div>
                          <div className="absolute md:h-[60px] h-[62px] left-[0] top-[31%] w-[48%]">
                            <div className="absolute bottom-[0] flex flex-col items-center justify-start left-[0] w-[82%]">
                              <div className="md:h-9 h-[38px] relative w-full">
                                <div className="absolute md:h-9 h-[37px] inset-[0] justify-center m-auto w-full">
                                  <Img
                                    className="absolute bottom-[0] h-[35px] inset-x-[0] mx-auto"
                                    src="images/img_rewind.svg"
                                    alt="rewind"
                                  />
                                  <Img
                                    className="absolute h-9 inset-[0] justify-center m-auto"
                                    src="images/img_xmlid5884.svg"
                                    alt="xmlid5884"
                                  />
                                </div>
                                <div
                                  className="absolute bg-cover bg-no-repeat md:h-[15px] h-[33px] inset-x-[0] mx-auto pb-[7px] pr-[7px] top-[0] w-[97%]"
                                  style={{
                                    backgroundImage:
                                      "url('images/img_group38.svg')",
                                  }}
                                >
                                  <div className="absolute md:h-2.5 h-5 left-[17%] top-[18%] w-[59%]">
                                    <div className="md:h-2.5 h-5 m-auto w-full">
                                      <div className="md:h-2.5 h-5 m-auto w-full">
                                        <div className="absolute md:h-2.5 h-3 left-[0] top-[0] w-[65%]">
                                          <div className="absolute md:h-2.5 h-[11px] left-[0] top-[0] w-[91%]">
                                            <Img
                                              className="absolute h-2.5 left-[0] top-[0]"
                                              src="images/img_checkmark.svg"
                                              alt="checkmark"
                                            />
                                            <Img
                                              className="absolute bottom-[0] h-2.5 right-[0]"
                                              src="images/img_checkmark.svg"
                                              alt="checkmark_One"
                                            />
                                          </div>
                                          <Img
                                            className="absolute bottom-[0] h-2.5 right-[0]"
                                            src="images/img_checkmark.svg"
                                            alt="checkmark_Two"
                                          />
                                        </div>
                                        <Img
                                          className="absolute bottom-[0] h-2.5 right-[0]"
                                          src="images/img_checkmark.svg"
                                          alt="checkmark_Three"
                                        />
                                      </div>
                                      <div className="absolute md:h-1 h-[7px] right-[12%] top-1/4 w-[36%]">
                                        <div className="absolute bottom-[0] md:h-0.5 h-1 right-[0] w-3/4">
                                          <Text
                                            className="absolute bottom-[0] right-[0] rotate-[45deg] text-[2.84px] text-gray-300"
                                            size="txtInterRegular284"
                                          >
                                            544
                                          </Text>
                                          <Text
                                            className="absolute left-[0] rotate-[45deg] text-[2.84px] text-gray-300 top-[0]"
                                            size="txtInterRegular284"
                                          >
                                            216
                                          </Text>
                                        </div>
                                        <Text
                                          className="absolute left-[0] rotate-[45deg] text-[2.84px] text-gray-300 top-[0]"
                                          size="txtInterRegular284"
                                        >
                                          954
                                        </Text>
                                        <Text
                                          className="absolute bottom-[0] left-[0] rotate-[45deg] text-[2.84px] text-gray-300"
                                          size="txtInterRegular284"
                                        >
                                          +
                                        </Text>
                                      </div>
                                    </div>
                                    <div className="absolute bottom-[10%] flex flex-col items-start justify-start left-[26%] w-[36%]">
                                      <Text
                                        className="rotate-[45deg] text-[2.84px] text-gray-300"
                                        size="txtInterRegular284"
                                      >
                                        984
                                      </Text>
                                      <div className="h-1 relative w-full">
                                        <Text
                                          className="absolute bottom-[0] right-[0] rotate-[45deg] text-[2.84px] text-gray-300"
                                          size="txtInterRegular284"
                                        >
                                          914
                                        </Text>
                                        <div className="absolute h-1 inset-y-[0] left-[0] my-auto w-[73%]">
                                          <Text
                                            className="absolute right-[0] rotate-[45deg] text-[2.84px] text-gray-300 top-[0]"
                                            size="txtInterRegular284"
                                          >
                                            356
                                          </Text>
                                          <Text
                                            className="absolute bottom-[0] left-[0] rotate-[45deg] text-[2.84px] text-gray-300"
                                            size="txtInterRegular284"
                                          >
                                            +
                                          </Text>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="absolute bg-cover bg-no-repeat flex flex-col h-[15px] items-center justify-start left-[0] top-[0] w-[45%]"
                                    style={{
                                      backgroundImage:
                                        "url('images/img_group39.svg')",
                                    }}
                                  >
                                    <Img
                                      className="h-[15px]"
                                      src="images/img_group.svg"
                                      alt="group_One"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Img
                              className="absolute h-[60px] inset-y-[0] my-auto right-[0]"
                              src="images/img_checkmark_deep_orange_200.svg"
                              alt="checkmark_Four"
                            />
                          </div>
                        </div>
                        <Img
                          className="absolute h-[39px] left-[33%] top-[30%]"
                          src="images/img_vector.svg"
                          alt="vector"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <Img
                  className="absolute h-[86px] right-[13%] top-[4%]"
                  src="images/img_file.svg"
                  alt="file"
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 items-center justify-start w-auto sm:w-full">
              <Text
                className="text-2xl md:text-[22px] text-center text-gray-900 sm:text-xl tracking-[0.20px] w-[525px]"
                size="txtInterBold24"
              >
                <>&quot;Optimize inventory and products with ERP&quot;</>
              </Text>
              <Text
                className="text-blue_gray-800_99 text-center text-sm w-auto"
                size="txtInterRegular14"
              >
                All your essential features in a highly customizable application
              </Text>
            </div>
          </div>
          <div className="flex flex-col gap-2.5 justify-start md:mt-0 mt-[111px] w-[38%] md:w-full">
            <div className="flex flex-row gap-[9px] items-center justify-start ml-9 md:ml-[0] md:pr-10 sm:pr-5 pr-[83px] w-[54%] md:w-full">
              <Img
                className="h-[34px] w-[34px]"
                src="images/img_music.svg"
                alt="music"
              />
              <Text
                className="md:text-4xl sm:text-[34px] text-[38px] text-blue-A700 tracking-[0.20px]"
                size="txtInterSemiBold38"
              >
                PurpleFusion
              </Text>
            </div>
            <div className="flex flex-col items-center justify-end p-[21px] sm:px-5 w-full">
              <form action="">
                <div className="flex flex-col gap-5 items-start justify-start mt-2.5 w-auto sm:w-full">
                  <div className="flex flex-col gap-3 items-start justify-start w-auto">
                    <Text
                      className="text-2xl md:text-[22px] text-gray-900 sm:text-xl tracking-[0.20px] w-auto"
                      size="txtInterBold24"
                    >
                      Login{" "}
                    </Text>
                    <Text
                      className="text-blue_gray-500 text-sm w-auto"
                      size="txtInterRegular14Bluegray500"
                    >
                      Welcome back! please enter your details
                    </Text>
                  </div>
                  <div className="flex flex-col gap-4 items-start justify-start w-[404px] sm:w-full">
                    <Input
                      // name="formlabelTwo"
                      placeholder="Enter Your Email Id"
                      className="md:h-auto p-0 placeholder:text-blue_gray-300 sm:h-auto text-base text-left w-full"
                      wrapClassName="flex w-full"
                      type="email"
                      onChange={(value) => {
                        setEmail(value);
                        handleInputChange("email", value);
                       // setSelectedCompany("")
                      }}
                      prefix={
                        <Img
                          className="h-6 mr-3 my-auto"
                          src="images/img_mail.svg"
                          alt="mail"
                        />
                      }
                      shape="round"
                      size="sm"
                    ></Input>
                    <Input
                      // name="formlabelThree"
                      placeholder="Password"
                      className="md:h-auto p-0 placeholder:text-blue_gray-300 sm:h-auto text-base text-left w-full"
                      wrapClassName="flex w-full"
                      // type="password"
                      type={`${!showpass ? "password" : "text"}`}
                      onChange={(value) =>
                        handleInputChange("login_password", value)
                      }
                      prefix={
                        <Img
                          className="h-6 mr-3 my-auto"
                          src="images/img_lock.svg"
                          alt="lock"
                        />
                      }
                      suffix={
                        // <Img
                        //   className="h-6 ml-[35px] my-auto"
                        //   src="images/img_location.svg"
                        //   alt="location"
                        // />
                        <button
                          type="button"
                          onClick={() => setShowpass(!showpass)}
                        >
                          {showpass == true ? <IoEye /> : <FaEyeSlash />}
                        </button>
                      }
                      shape="round"
                      size="sm"
                    ></Input>
                  </div>
                  <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full ">
                    <Text
                      className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                      size="txtInterMedium20Black900"
                    >
                      <span className="text-black-700 font-inter font-small text-sm">
                        Select Company
                      </span>
                      <span className="text-red-A700 font-inter font-small text-sm">
                        *
                      </span>
                    </Text>

                    <Select
                      name="company_id"
                      value={company
                        .map((item) => ({ label: item.companyname, value: item.company_id }))
                        .find((opt) => opt.value === selectedCompany) || null}
                      options={company.map((item) => ({
                        label: item.companyname,
                        value: item.company_id,
                      }))}
                      className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                      onChange={(opt) => {
                        setSelectedCompany(opt.value);
                        handleInputChange("company_id", opt.value);
                      }}
                      placeholder="Select Company"
                    />
                  </div>

                  <div className="flex flex-row gap-[146px] items-end justify-between w-auto sm:w-full">
                    {/* <CheckBox
                    className="font-medium text-left text-sm tracking-[0.20px]"
                    inputClassName="h-6 mr-[5px] w-6"
                    name="rememberme"
                    id="rememberme"
                    label="Remember me"
                    color="indigo_50"
                  ></CheckBox> */}
                    <span
                      // href="javascript:"
                      className="text-blue-A700 text-right text-sm w-auto cursor-pointer"
                    >
                      <Text size="txtInterBold14" onClick={() => otpSubmit()}>
                        Forgot Password?
                      </Text>
                    </span>
                  </div>
                  {/* <ReCAPTCHA
                    sitekey="6LdCTIUrAAAAAMCLi2pAjAsSB0O_v9S678FuhS9U"
                    onChange={onCaptchaChange}
                  /> */}
                  <Button
                    type="submit"
                    className="cursor-pointer font-bold h-14 rounded-[12px] text-base text-center tracking-[0.20px] w-[404px]"
                    color="blue_A700"
                    size="lg"
                    variant="fill"
                    onClick={(e) => onHandleSubmit(e)}
                  >
                    Log In
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogInEmptyPage;
